/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import {
    getPolicySingle,
    extendSubjectivity,
    getSubjectivity,
    markSubjectivityAsCompleted,
    cancelPolicy,
    downloadPolicyScheme,
    getPolicyMTA,
} from '../../../../actions'

/**
 * Import
 * - Page component
 */
import ViewPolicies from '../../../../components/pages/Policies/View/View'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        policy: state.policiesSingle,
        subjectivities: state.subjectivities,
        fullPolicy: state.mta.policy,
    }
}

export default connect(
    mapStateToProps,
    {
        quote: 'The Policy! Summary',
        getPolicySingle: getPolicySingle,
        extendSubjectivity: extendSubjectivity,
        getSubjectivity: getSubjectivity,
        markSubjectivityAsCompleted: markSubjectivityAsCompleted,
        cancelPolicy: cancelPolicy,
        downloadPolicyScheme: downloadPolicyScheme,
        getPolicyMTA: getPolicyMTA,
    }
)(ViewPolicies)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Policies/View/View.tsx